import React, {useEffect, useState} from 'react';
import './styles.scss';
import {connect} from 'react-redux';
import {
  addToGlobalStyles,
  addToWizard,
  setWizard,
  setSelectedBu,
  setAvailableBus,
  setIsAuthenticated,
  setConsultasOnlineEnabled,
  setLanguageOptions,
  setIbanFilterOpenTrigger,
  setDisableReimbursementRequestButton,
  setUserBankAccountDataWasUpdated,
  setIban,
  setTitular,
} from '../../store/actions';
import {compose} from 'redux';
import {Column, Row} from '../../components/layout';
import colors, {pageBackgrounds} from '../../util/colors';
import MyServices from './my-services';
import MyReimbursements from './my-reimbursements';
import MyCoverages from './my-coverages';
import {get} from '../../api/api';
import {uriGetTopV2Coverages, uriMemberData} from '../../api/endpoints';
import {functionalitiesAliasMap, strings} from '../../util/strings';
import {limitArray} from '../../util/utility';
import HomepageDivider from '../../components/dividers/homepage-divider';
import AppButton from '../../components/app-button';
import {useHistory} from 'react-router-dom';
import AdvanceCarePlus from '../../components/advance-care-plus';
// import {uriGetHealthScore} from '../../api/endpoints';
import ModalTemplate from '../../components/modal';
import * as fonts from '../../util/fonts';
import Icon from './../../components/icon/index';
import {Icons} from '../../util/icons';
import MedicoOnline from './medico-online';
import NewPageLoader from '../../components/page-loader/NewPageLoader';
import logEvent from '../../analytics/googleAnalytics';

export interface HomepageProps {
  labelsRefund: typeof strings.pt.refund;
  labelsCoverages: typeof strings.pt.myCoverages;
  labelsIban: typeof strings.pt.ibanRefunds;
  labelsCreateRefund: typeof strings.pt.createRefund;
  labelsMessages: typeof strings.pt.messages;
  stringsDefault: any;
  selectedBu: any;
  wizard: any;
  addToWizard(value: any): void;
  addToGlobalStyles(value: any): void;
  setSelectedBu(value: any): void;
  setAvailableBus(value: any): void;
  setWizard(value: any): void;
  setConsultasOnlineEnabled(value: any): void;
  setDisableReimbursementRequestButton(value: any): void;
  setLanguageOptions: Function;
  setIbanFilterOpenTrigger: Function;
  user: any;
  busFuncMap: any;
  loadingInfo: boolean;
  iban: any;
  titular: any;
  accessToken: any;
  languageOptions: any;
  busMap: any;
  buStyles: any;
  bankAccountDataHolder: any;
  userBankAccountDataWasUpdated: boolean;
  stringsLoaded: boolean;
  setUserBankAccountDataWasUpdated: Function;
  setIban: Function;
  setTitular: Function;
  language: any;
}

const Homepage = ({
  stringsDefault,
  selectedBu,
  addToGlobalStyles,
  setWizard,
  setConsultasOnlineEnabled,
  user,
  loadingInfo,
  busFuncMap,
  labelsRefund,
  labelsCoverages,
  labelsIban,
  labelsCreateRefund,
  labelsMessages,
  iban,
  titular,
  accessToken,
  languageOptions,
  setLanguageOptions,
  buStyles,
  bankAccountDataHolder,
  busMap,
  setIbanFilterOpenTrigger,
  setDisableReimbursementRequestButton,
  userBankAccountDataWasUpdated,
  setUserBankAccountDataWasUpdated,
  stringsLoaded,
  setIban,
  setTitular,
  language,
}: HomepageProps) => {
  const history = useHistory();
  const [healthScore, setHealthScore] = useState<any>('');
  const [showModalIban, setShowModalIban] = useState(false);
  const [divider, setDivider] = useState(true);
  const [coveragesList, setCoveragesList] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [oneFuncActive, setOneFuncActive] = useState(true);
  const [medicoOnline, setMedicoOnline] = useState();
  const [medicOnlineDisabled, setMedicOnlineDisabled] = useState(false);
  const [servicesEmpty, setServicesEmpty] = useState(false);
  const [canCreateReimbursment, setCanCreateReimbursement] = useState(false);
  const [currency, setCurrency] = useState();
  const [disableCreateRefundButton, setDisableCreateRefundButton] =
    useState(false);
  const [msgBelowCreateRefundButton, setMsgBelowCreateRefundButton] =
    useState<any>(<></>);
  const [canCreateWithMessage, setCanCreateWithMessage] = useState(false);
  const [ibanFuncActive, setIbanFuncActive] = useState(false);

  const tenantAlias = process.env.REACT_APP_DEFAULT_TENANT_ALIAS;
  const featureName = 'Homepage';

  const isTitularLogged =
    bankAccountDataHolder === 'SUBSCRIBER'
      ? titular?.memId === selectedBu?.memId &&
        titular?.buId === selectedBu?.buId
      : true;

  const createRefundActive = busFuncMap[selectedBu.buId]?.find(
    (func: any) =>
      func.featureTemplateAlias === functionalitiesAliasMap.createRefund,
  );

  const handleDefineIban = () => {
    setIbanFilterOpenTrigger({ibanFilter: true});
    history.push({pathname: '/perfil', state: {openIban: true}});
  };

  const processCanCreateReimbursement = () => {
    if (!createRefundActive || !createRefundActive?.isVisible) {
      setCanCreateReimbursement(false);
    } else {
      if (!ibanFuncActive) {
        setCanCreateReimbursement(true);
      } else {
        if (labelsIban?.ibanRefunds_ibanIsEnabled === '1') {
          if (!titular?.iban) {
            setCanCreateReimbursement(false);
          } else {
            setCanCreateReimbursement(true);
          }
        } else {
          setCanCreateReimbursement(true);
        }
      }
    }
  };

  // const getHealthScore = async () => {
  //   const nif = user.nif;
  //   try {
  //     const response: any = await get(
  //       uriGetHealthScore(nif, true),
  //       false,
  //       0,
  //       featureName
  //     );
  //     setHealthScore(response?.data);
  //   } catch (e: any) {
  //     setHealthScore(undefined);
  //   }
  // };

  useEffect(() => {
    setIbanFuncActive(
      busFuncMap?.[selectedBu?.buId]?.find(
        (func: any) =>
          func?.featureTemplateAlias === functionalitiesAliasMap.iban,
      )?.isVisible,
    );
  }, [busFuncMap, selectedBu]);

  useEffect(() => {
    const getMemberData = async () => {
      const memberData: any = await get(
        uriMemberData(selectedBu?.buId, selectedBu?.memId, selectedBu?.famId),
        false,
        0,
        featureName,
      );
      if (bankAccountDataHolder == 'INDIVIDUAL') {
        setIban(memberData?.data?.iban);
        setTitular(memberData?.data);
      }
      setUserBankAccountDataWasUpdated(false);
    };

    selectedBu?.memId && userBankAccountDataWasUpdated && getMemberData();
  }, [selectedBu]);

  // useEffect(() => {
  //   const find =
  //     busFuncMap &&
  //     busFuncMap[selectedBu.buId]?.find(
  //       (func: any) =>
  //         func?.isVisible &&
  //         functionalitiesAliasMap.healthScore === func?.featureTemplateAlias
  //     );
  //   addToGlobalStyles({background: pageBackgrounds.homePage});

  //   if (accessToken && find) {
  //     getHealthScore();
  //   }
  // }, [selectedBu.memId]);

  //Get Coverages List
  useEffect(() => {
    const isAuthClient =
      accessToken && selectedBu && selectedBu.buId !== 'NOTCLIENT';
    setIsLoading(true);
    const getCoveragesList = async () => {
      try {
        let response: any;

        response = await get(
          uriGetTopV2Coverages(
            selectedBu.buId,
            selectedBu.memId,
            selectedBu.benNbr,
          ),
          false,
          0,
          featureName,
        );

        setCoveragesList(limitArray(response.data.items, 2));
      } catch (e: any) {
        setCoveragesList([]);
      } finally {
        setIsLoading(false);
      }
    };

    if (isAuthClient) {
      getCoveragesList();
    }
  }, [selectedBu.memId]);

  //useEffect usado apenas para o layout das coberturas/reembolsos pois se for usado noutros useEffects estabelece
  // o layout demasiado cedo, o que torna inconsistente o resultado desejado (se houver apenas uma funcionalidade na linha, centrar)
  useEffect(() => {
    checkFuncsInRow();
  }, [busFuncMap[selectedBu.buId]]);

  useEffect(() => {
    setDisableReimbursementRequestButton(disableCreateRefundButton);
  }, [disableCreateRefundButton]);

  useEffect(() => {
    processCanCreateReimbursement();
    const messageBelowCreateRefundButton = () => {
      if (labelsIban?.ibanRefunds_ibanIsEnabled === '1') {
        switch (labelsIban?.ibanRefunds_bankAccountDataRequiredForRefunds) {
          case '0': {
            return isTitularLogged && ibanFuncActive ? (
              <>
                {labelsCreateRefund?.refund_alert_owner_1}
                <a
                  className="define-iban-anchor-label"
                  style={{
                    ...fonts.SM,
                    color: buStyles?.primaryColor || colors.blue,
                    textDecoration: 'underline',
                  }}
                  onClick={() => handleDefineIban()}>
                  {labelsCreateRefund?.refund_alert_owner_2}
                </a>
              </>
            ) : (
              <span key={selectedBu.famId}>
                {ibanFuncActive && labelsCreateRefund?.refund_alert_not_owner}
              </span>
            );
          }
          case '1': {
            switch (bankAccountDataHolder) {
              case 'SUBSCRIBER': {
                if (titular?.iban) {
                  setDisableCreateRefundButton(false);
                  return;
                }
                setDisableCreateRefundButton(!titular?.iban || !ibanFuncActive);
                return isTitularLogged && !titular?.iban ? (
                  <Row className="fill-iban-here">
                    <span>{labelsIban?.ibanRefunds_fillIbanMyData} </span>
                    <a
                      className="define-iban-anchor-label"
                      style={{
                        color: buStyles?.primaryColor || colors.blue,
                        textDecoration: 'underline',
                        marginLeft: '3px',
                      }}
                      onClick={() => {
                        setIbanFilterOpenTrigger({ibanFilter: true});
                        history.push({
                          pathname: '/perfil',
                          state: {patientSelected: selectedBu},
                        });
                      }}>
                      {labelsIban?.ibanRefunds_fillIbanMyDataLink}
                    </a>
                  </Row>
                ) : (
                  <span key={selectedBu.famId} className="semibold">
                    {labelsIban?.ibanRefunds_fillIbanAskTitular}
                  </span>
                );
              }
              case 'INDIVIDUAL': {
                setDisableCreateRefundButton(!titular?.iban || !ibanFuncActive);
                return (
                  !titular?.iban && (
                    <Row className="fill-iban-here">
                      <span>{labelsIban?.ibanRefunds_fillIbanMyData} </span>
                      <a
                        className="define-iban-anchor-label"
                        style={{
                          color: buStyles?.primaryColor || colors.blue,
                          textDecoration: 'underline',
                          marginLeft: '3px',
                        }}
                        onClick={() =>
                          history.push({
                            pathname: '/perfil',
                            state: {patientSelected: selectedBu},
                          })
                        }>
                        {labelsIban?.ibanRefunds_fillIbanMyDataLink}
                      </a>
                    </Row>
                  )
                );
              }
            }
          }
        }
      } else {
        if (isTitularLogged) {
          if (
            labelsIban?.ibanRefunds_bankAccountDataRequiredForRefunds == '1'
          ) {
            setCanCreateWithMessage(true);
          }
          return (
            !titular?.iban && (
              <p className="semibold">
                {labelsIban?.ibanRefunds_fillIbanAskInsuranceCompany}
              </p>
            )
          );
        } else {
          if (
            labelsIban?.ibanRefunds_bankAccountDataRequiredForRefunds == '1'
          ) {
            setCanCreateWithMessage(true);
            return (
              !titular?.iban && (
                <p className="semibold">
                  {labelsIban?.ibanRefunds_fillIbanAskInsuranceCompanyNotOwner}
                </p>
              )
            );
          } else {
            return (
              !titular?.iban && (
                <p className="semibold">
                  {labelsIban?.ibanRefunds_fillIbanAskInsuranceCompanyNotOwner}
                </p>
              )
            );
          }
        }
      }
    };

    // !titular?.iban &&
    //   setDisableCreateRefundButton(
    //     !ibanFuncActive &&
    //       labelsIban?.ibanRefunds_bankAccountDataRequiredForRefunds == '1'
    //   );
    ibanFuncActive &&
      setMsgBelowCreateRefundButton(messageBelowCreateRefundButton());
  }, [selectedBu.memId, titular, ibanFuncActive]);

  const checkFuncsInRow = async () => {
    let reimbursement = false;
    let coverages = false;
    busFuncMap[selectedBu.buId]?.map((func: any) => {
      if (
        func?.isVisible &&
        functionalitiesAliasMap.refund === func?.featureTemplateAlias
      ) {
        reimbursement = true;
      }
      if (
        func?.isVisible &&
        functionalitiesAliasMap.coverages === func?.featureTemplateAlias
      ) {
        coverages = true;
      }
    });
    if (coverages && reimbursement) {
      setOneFuncActive(false);
    } else {
      setOneFuncActive(true);
    }
  };

  const changeMedicoOnline = (service: any) => {
    setMedicoOnline(service);
  };

  const changeMedicOnlineDisabled = (value: boolean) => {
    setMedicOnlineDisabled(value);
  };

  const changeServicesEmpty = (value: any) => {
    setServicesEmpty(value);
  };

  const checkConsultaOnline = () => {
    const consultaOnlineActive =
      busFuncMap?.[selectedBu?.buId]?.some(
        (func: any) =>
          func?.isVisible &&
          func?.featureTemplateAlias === functionalitiesAliasMap.services,
      ) &&
      busFuncMap?.[selectedBu?.buId]?.some(
        (func: any) =>
          func?.isVisible &&
          func?.featureTemplateAlias === functionalitiesAliasMap.appointments,
      );

    setConsultasOnlineEnabled(consultaOnlineActive);
    return consultaOnlineActive;
  };

  return localStorage.getItem('access_token') === '' || !stringsLoaded ? (
    <div className="loading-page-container">
      <NewPageLoader />
    </div>
  ) : (
    <>
      {
        <>
          {labelsMessages?.instability_alert_active_web === '1' && (
            <Row className="instability-alert-row">
              <Icon
                width="20"
                height="20"
                color={colors.black}
                name={Icons.ALERT_PROBLEM}
                changeViewbox
                viewBox={'0 0 24 24'}
                className="instability-alert-icon"
              />
              <p
                style={{...fonts.Medium, ...fonts.M}}
                className="instability-alert-p">
                {tenantAlias === 'PT'
                  ? labelsMessages?.instability_alert_web
                  : 'Radimo na poboljšanju vašeg iskustva. Tokom ovog perioda, može doći do povremenih prekida u radu. Hvala vam na strpljenju.'}
              </p>
            </Row>
          )}
          <Row className="homepage-row app-center">
            <MedicoOnline
              medicoOnline={medicoOnline}
              medicoOnlineDisabled={medicOnlineDisabled}
              visible={checkConsultaOnline()}
            />
          </Row>
          <Row
            className="homepage-row app-center"
            style={{paddingLeft: '5%', paddingRight: '5%'}}>
            {busFuncMap ? (
              busFuncMap[selectedBu.buId]?.map((func: any, index: number) => {
                if (
                  func?.isVisible &&
                  functionalitiesAliasMap.services ===
                    func?.featureTemplateAlias
                ) {
                  return (
                    <MyServices
                      key={index}
                      setMedicoOnline={(service: any) =>
                        changeMedicoOnline(service)
                      }
                      setServicesEmpty={(value: any) =>
                        changeServicesEmpty(value)
                      }
                      setMedicOnlineDisabled={(value: boolean) =>
                        changeMedicOnlineDisabled(value)
                      }
                    />
                  );
                }
              })
            ) : (
              <></>
            )}
          </Row>
          {selectedBu?.buId !== 'NOTCLIENT' && (
            <Row
              className="homepage-row app-center homepage-reimbursements-coverages"
              style={{
                backgroundColor: colors.backgroundGrey,
                justifyContent: !oneFuncActive ? 'space-between' : 'center',
                alignItems: 'flex-start',
              }}>
              {busFuncMap ? (
                busFuncMap[selectedBu.buId]?.map((func: any, index: number) => {
                  if (
                    func?.isVisible &&
                    functionalitiesAliasMap.refund ===
                      func?.featureTemplateAlias
                  ) {
                    return (
                      <Column
                        key={index}
                        className="homepage-reimbursements-col">
                        <MyReimbursements setCurrency={setCurrency} />

                        {createRefundActive?.isVisible && (
                          <>
                            <AppButton
                              disabled={disableCreateRefundButton}
                              onClick={() => {
                                setWizard({
                                  currency: currency,
                                });
                                logEvent('Refund_Request', {
                                  event_type: 'click',
                                  source: 'portal',
                                });
                                history.push(
                                  '/historico-reembolsos/pedido-reembolso',
                                );
                              }}
                              className={
                                language === 'sr-RS'
                                  ? 'homepage-request-reimbursement-button-rs'
                                  : 'homepage-request-reimbursement-button'
                              }>
                              {labelsRefund?.refundHistory_addRefund}
                            </AppButton>
                            {(!canCreateReimbursment ||
                              disableCreateRefundButton ||
                              canCreateWithMessage) && (
                              <>
                                <div
                                  className={'create-refund-alert'}
                                  style={{
                                    ...fonts.SM,
                                    ...fonts.SemiBold,
                                  }}
                                  key={selectedBu.famId}>
                                  {/* {isTitularLogged ? (
                                        <>
                                          {
                                            labelsCreateRefund?.refund_alert_owner_1
                                          }
                                          <a
                                            className="define-iban-anchor-label"
                                            style={{
                                              ...fonts.SM,
                                              color:
                                                buStyles?.primaryColor ||
                                                colors.blue,
                                              textDecoration: 'underline',
                                            }}
                                            onClick={() => handleDefineIban()}>
                                            {
                                              labelsCreateRefund?.refund_alert_owner_2
                                            }
                                          </a>
                                        </>
                                      ) : (
                                        <span>
                                          {
                                            labelsCreateRefund?.refund_alert_not_owner
                                          }
                                        </span>
                                      )} */}
                                  {msgBelowCreateRefundButton}
                                </div>
                              </>
                            )}
                          </>
                        )}
                        <ModalTemplate
                          type="error"
                          inputType="confirm"
                          show={showModalIban}
                          onHide={() => setShowModalIban(false)}
                          cross={false}
                          hideFooter>
                          <Column>
                            <div
                              style={{
                                ...fonts.M,
                                color: colors.alertRed,
                                fontWeight: 'bold',
                              }}>
                              {isTitularLogged
                                ? labelsRefund?.refundHistory_ibanError
                                : labelsRefund?.refundHistory_ibanError_not_titular}
                            </div>
                          </Column>
                          <AppButton
                            onClick={() => {
                              isTitularLogged
                                ? history.push('/perfil')
                                : setShowModalIban(false);
                            }}
                            style={{
                              margin: '20px',
                              marginInline: 'auto',
                            }}>
                            {isTitularLogged
                              ? labelsRefund?.refundHistory_defineIban
                              : labelsRefund?.refundHistory_understood}
                          </AppButton>
                        </ModalTemplate>
                      </Column>
                    );
                  }
                })
              ) : (
                <></>
              )}
              {busFuncMap ? (
                busFuncMap[selectedBu.buId]?.map((func: any, index: number) => {
                  if (
                    func?.isVisible &&
                    functionalitiesAliasMap.coverages ===
                      func?.featureTemplateAlias
                  ) {
                    return (
                      <Column
                        key={index}
                        className={
                          createRefundActive?.isVisible
                            ? 'homepage-reimbursements-coverages-col-w-button'
                            : 'homepage-reimbursements-coverages-col'
                        }>
                        <MyCoverages
                          coveragesList={coveragesList}
                          isLoading={isLoading}
                        />
                        {labelsCoverages?.listType === 'LISTA' && (
                          <AppButton
                            variant="secondary"
                            onClick={() => {
                              history.push('/minhas-coberturas');
                            }}
                            className="homepage-coverages-button">
                            {labelsCoverages?.seeAll}
                          </AppButton>
                        )}
                      </Column>
                    );
                  }
                })
              ) : (
                <></>
              )}
            </Row>
          )}
          {divider && <HomepageDivider />}

          {busFuncMap
            ? busFuncMap[selectedBu.buId]?.map((func: any) => {
                if (
                  func?.isVisible &&
                  functionalitiesAliasMap.healthScore ===
                    func?.featureTemplateAlias
                ) {
                  return (
                    <Row className="justify-content-center">
                      {!!healthScore && (
                        <AdvanceCarePlus
                          healthScore={healthScore}></AdvanceCarePlus>
                      )}
                    </Row>
                  );
                }
              })
            : null}
        </>
        /* <Row className="homepage-row app-center">
        <MyScore />
      </Row>
      <Row className="homepage-row app-center">
        <Articles />
      </Row>
      <Row className="homepage-row app-center">
        <Programs />
      </Row>
      <Row className="homepage-row app-center">
        <PhoneAppAd />
      </Row> */
      }
    </>
  );
};

const mapStateToProps = ({
  wizard,
  strings,
  stringsDefault,
  selectedBu,
  loadingInfo,
  user,
  busFuncMap,
  iban,
  titular,
  accessToken,
  languageOptions,
  busMap,
  globalStyles,
  bankAccountDataHolder,
  userBankAccountDataWasUpdated,
  stringsLoaded,
  language,
}: any) => ({
  wizard: wizard.value,
  labelsRefund: strings.value.pt.refund,
  labelsCreateRefund: strings.value.pt.createRefund,
  labelsIban: strings.value.pt.ibanRefunds,
  labelsMessages: strings.value.pt.messages,
  stringsDefault: stringsDefault.value.pt.messages,
  labelsCoverages: strings.value.pt.myCoverages,
  selectedBu: selectedBu.value,
  user: user.value,
  loadingInfo: loadingInfo.value,
  busFuncMap: busFuncMap.value,
  iban: iban.value,
  titular: titular.value,
  accessToken: accessToken.value,
  languageOptions: languageOptions.value,
  busMap: busMap.value,
  buStyles: globalStyles.value,
  bankAccountDataHolder: bankAccountDataHolder.value,
  userBankAccountDataWasUpdated: userBankAccountDataWasUpdated.value,
  stringsLoaded: stringsLoaded.value,
  language: language.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  setWizard: (value: any) => dispatch(setWizard(value)),
  setIban: (value: any) => dispatch(setIban(value)),
  setTitular: (value: any) => dispatch(setTitular(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
  addToGlobalStyles: (value: any) => dispatch(addToGlobalStyles(value)),
  setSelectedBu: (value: any) => dispatch(setSelectedBu(value)),
  setAvailableBus: (value: any) => dispatch(setAvailableBus(value)),
  setIsAuthenticated: (value: any) => dispatch(setIsAuthenticated(value)),
  setLanguageOptions: (value: any) => dispatch(setLanguageOptions(value)),
  setIbanFilterOpenTrigger: (value: any) =>
    dispatch(setIbanFilterOpenTrigger(value)),
  setConsultasOnlineEnabled: (value: any) =>
    dispatch(setConsultasOnlineEnabled(value)),
  setDisableReimbursementRequestButton: (value: any) =>
    dispatch(setDisableReimbursementRequestButton(value)),
  setUserBankAccountDataWasUpdated: (value: any) =>
    dispatch(setUserBankAccountDataWasUpdated(value)),
});

export default compose(connect(mapStateToProps, mapDispatchToProps)(Homepage));
